module.exports = __webpack_public_path__ + "static/media/check.0868c472.svg";